import { render } from "./Socials.vue?vue&type=template&id=da8d971c&scoped=true"
import script from "./Socials.vue?vue&type=script&lang=js"
export * from "./Socials.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-da8d971c"

export default script